// src/components/ContactInfo.js

const ContactInfo = () => {
  return <></>;
};

export default ContactInfo;
